<template>
    <div>
        <!--<template v-for="(node,index) in nodes" >
            <el-submenu :index="node.id+''"  v-if="!node.hidden&&node.children&&node.children.length>0">
                <template slot="title">
                    <i :class="node.icon"></i>
                    <span slot="title">{{(node.name)}}</span>
                </template>
                <menu-tree :nodes="node.children"></menu-tree>
            </el-submenu>
            &lt;!&ndash; 这里是用:route="{name:node.name}，如果不使用name跳转的话，可以在数据源那里把path写成全路径即可 &ndash;&gt;
            <el-menu-item :index="node.path" v-if="!node.hidden&&node.children&&node.children.length==0">
                <i :class="node.icon"></i>
                <span slot="title">     {{(node.name)}}</span>
            </el-menu-item>
        </template>-->
        <template v-for="(node,index) in nodes" >
            <template v-if="!node.hidden&&node.children&&node.children.length>0">
                <el-submenu :index="node.id+''" :key="node.id+''">
                    <template slot="title">
                        <i :class="node.icon"></i><span slot="title">{{ node.name }}</span>
                    </template>
                    <template v-for="(node2,index2) in node.children">
                        <el-submenu v-if="!node2.hidden&&node2.children&&node2.children.length>0" :index="node2.id+''" :key="node2.id+''">
                            <i :class="node2.icon"/><template slot="title">{{ node2.name }}</template>
                            <el-menu-item v-for="(node3,index3) in node2.children" :key="node3.path" :index="node3.path">
                                <i :class="node3.icon"/>{{ node3.name }}
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-else :index="node2.path" :key="node2.path">
                            <i :class="node2.icon"/>{{ node2.name }}
                        </el-menu-item>
                    </template>
                </el-submenu>
            </template>
            <template v-else>
                <el-menu-item :index="node.path" :key="node.path" v-if="!node.hidden&&node.children&&node.children.length==0">
                    <i :class="node.icon"/><span slot="title">{{ node.name }}</span>
                </el-menu-item>
            </template>
        </template>
    </div>
</template>
<script>
    export default {
        props:['nodes'],
        name: 'MenuTree',
        data() {
            return {
            }
        },
        methods: {
        },
        mounted(){

        }
    }

</script>

<style scoped lang="scss">
    .fa{
        color:#2d2f33;
    }
    .el-menu--collapse{
        div{
            .el-submenu{
                .el-submenu__title{
                    span{
                        height: 0;
                        width: 0;
                        overflow: hidden;
                        visibility: hidden;
                        display: inline-block;
                    }
                }
            }
        }
    }

    li.el-menu-item{
        padding-left: 30px !important;
    }




</style>



// WEBPACK FOOTER //
// src/components/MenuTree.vue